module.exports = __webpack_public_path__ + "static/media/country_cv.b01d2ff0.webp";